module.exports = __webpack_public_path__ + "static/media/medal.1dd6a78c.svg";